<form class="edit-customer-info" [formGroup]="accountDataForm">

    <div class="edit-customer-info-header">

        <rpc-button class="edit-customer-info-header-close" [iconName]="'cross'"
            [title]="'EDIT_PROFILE_INFO.TITLES.CLOSE'" (clicked)="onCancel()">
        </rpc-button>

        <div class="edit-customer-info-header-title rpc-title-font">
            {{ 'EDIT_PROFILE_INFO.TITLES.EDIT_PROFILE' | translate }}
        </div>

        <rpc-button class="edit-customer-info-header-action" [text]="'EDIT_PROFILE_INFO.TITLES.SAVE'" [color]="'accent'"
            [disabled]="accountDataForm?.invalid" (clicked)="onSave()">
        </rpc-button>

    </div>

    <div class="edit-customer-info-body">

        <rpc-input class="edit-customer-info-input" [type]="'text'" [appearance]="'fill'"
            [label]="'EDIT_PROFILE_INFO.TITLES.FIRST_NAME'" [options]="firstNameControlOptions">
        </rpc-input>

        <rpc-input class="edit-customer-info-input" [type]="'text'" [appearance]="'fill'"
            [label]="'EDIT_PROFILE_INFO.TITLES.LAST_NAME'" [options]="lastNameControlOptions">
        </rpc-input>

        @if (isAdditionalProfile) {

        <rpc-input class="edit-customer-info-input" [type]="'text'" [appearance]="'fill'"
            [label]="'EDIT_PROFILE_INFO.TITLES.EMAIL'" [options]="mainAdditionalProfileEmailOptions" [disabled]="true">
        </rpc-input>

        } @else {

        <rpc-select class="edit-customer-info-select" [color]="'accent'" [shouldTranslate]="false"
            [label]="'EDIT_PROFILE_INFO.TITLES.MAIN_EMAIL'" [controlOptions]="mainEmailSelectOptions"
            [appearance]="'fill'">
        </rpc-select>

        }

    </div>

    <div class="edit-customer-info-footer">

        <rpc-button [appearanceType]="'stroke'" [text]="'EDIT_PROFILE_INFO.TITLES.CANCEL'" (clicked)="onCancel()">
        </rpc-button>

        <rpc-button [color]="'accent'" [appearanceType]="'flat'" [text]="'EDIT_PROFILE_INFO.TITLES.SAVE'"
            [disabled]="accountDataForm?.invalid" (clicked)="onSave()">
        </rpc-button>

    </div>

</form>